import React, { Component } from "react";
import { connect } from "dva";
import TreeList from "../../components/TreeList";
import { GetQueryString } from "../../../../../utils/utils";
import NormView from "../components/NormView";
import styles from "./index.less";

@connect(({ tree, norm }) => ({
  ...norm,
  ...tree
}))
class NormSettingView extends Component {
  constructor(props) {
    super(props);
    const templateId = GetQueryString("currentNormId");
    const { respondentOrgId } = props;
    this.state = {
      type: 0,
      templateId,
      respondentOrgId: respondentOrgId || "",
      showComponent: true,
      showTree:false,
    };
  }

  // code、id、templateId三者的区别(请求接口都是用哪个)
  componentDidMount() {
    // 获取当前指标的id
    const { templateId, respondentOrgId } = this.state;

    const { dispatch } = this.props;
    dispatch({
      type: "tree/getNormTree",
      payload: {
        templateId,
        respondentOrgId
      },
      callback: this.handleGetTree
    });
  }

  componentDidUpdate() {
    const { showComponent } = this.state;
    if (!showComponent) {
      this.setState({
        showComponent: true
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/reset"
    });
  }

  // 已经获取树之后的回调
  handleGetTree = () => {
    const { dispatch } = this.props;
    this.setState({
      showTree: true
    });
  };

  handleSelect = props => {
    const { type, code } = props;
    this.setState({
      type,
      code,
      showComponent: false
    });
  };

  renderRoot = () => {
    this.setState({
      type: 0
    });
  };

  render() {
    const {
      type,
      templateId,
      code,
      showComponent,
      respondentOrgId,
      showTree
    } = this.state;
    const { templateType } = this.props;

    return (
      <div className={styles.settings}>
        <div className="container">
          <div className="norm-wrap">
            <div className="left-side">
              <div className="leftSideContainer">
                {showTree && <TreeList onSelect={this.handleSelect} expandAllTree />}
              </div>
            </div>
            <div className="right-side">
              <div className="rightSideContainer">
                {showComponent && (
                  <NormView
                    record={{
                      type,
                      templateId,
                      code,
                      templateType,
                      respondentOrgId
                    }}
                    renderRoot={this.renderRoot}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NormSettingView;
